import OapGeolocationPopin from './code/Scripts/Components/OapGeolocationPopin.vue';

export default {
  components: {
    OapGeolocationPopin,
  },
};
